module.exports = __webpack_public_path__ + "img/zhifu.e83d2488.png";